<template>
  <div id="GoodsList">
    <div class="list_slide_box">
      <div class="slide_box " v-for="(item, index) in list" :key="index" :class="[!isSold(item)||item.Status==0?'soldout':'',CountDown(item.LastOnTime)=='00:00'?'':'soldout']">
        <router-link :to="{path:'/storedetails/'+item._id}" target="_blank">
          <div class="like_box">
            <div class="iconsold" v-if="!isSold(item)||item.Status==0">{{$t('base.soldOut')}}</div>
            <div class="iconsold ReleaseType" v-if="item.Status==2&&CountDown(item.LastOnTime)!='00:00'">{{$t('base.comingSoon')}}</div>
            <el-image class="like_img" :src="item.Imgs[0]!='没有可上传的图片'?item.Imgs[0]+'?imageView2/2/w/200':'../static/images/noimg.svg'" fit="contain" lazy></el-image>
          </div>
          <div class="slide_txt">
            <p class="line_txt3" :title="item.Title">{{item.Title}}</p>
            <div class="price">
              <span >{{item.Currency}} {{isPrice(item)}}</span>
              <!-- <span class="text_gray bise_text line-through" v-if="islinedPrice(item)">{{isPrice(item,'delPrice')}}</span> -->
            </div>
            <div class="bids_box">
              <span class="icon_flash">{{$t('base.buyNow')}}</span>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { countDown, setUTC, getTime, setAttention, isNumber,formatAmount, getInfo, titleSubstring } from "@/api/public";
export default {
  name: "goodslist",
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
      userInfo: '',
      timer: "",
      nowData: new Date().getTime(),
    };
  },
  filters: {
    // setTimeSS(val) {
    //   if (val) {
    //     val = val.toString().replace(/-/g, "/")
    //   }
    //   return getTime(val, -8, 1, 'cn')
    // },
    // titleVal(data) {
    //   /* 商品列表标题截取 */
    //   return titleSubstring(data);
    // }
  },
  props: {
    list: {},
    StatusNum: "",
    type: ''
  },
  created() {
    this.userInfo = getInfo();
    this.cardTimer();
  },
  methods: {
    //是否售罄
    isSold(obj) {
      let that = this

      if (obj.Conditions) {
        var num = 0
        obj.Conditions.map((item, index) => {
          num += item.QuantitySold
        })
        return num > 0 ? true : false
      } else {
        return false
      }
    },
    islinedPrice(obj){
      let that = this
      var data = ''
      var initial = obj.Conditions
      initial = initial.filter(res => {
        return res.QuantitySold > 0
      })
      if (initial.length > 0) {
        data = initial[0]
      } else {
        data = obj.Conditions[0]
      }
      if (obj.Status == 1) {
        return isNumber(data.UnderlinedPrice)>0?true:false
      } else {
        if (data) {
          return isNumber(data.UnderlinedPrice)>0?true:false
        } else {
          return false
        }
      }
      
    },
    // 显示商品价格
    isPrice(obj,val) {
      let that = this
      var data = ''
      var initial = obj.Conditions
      initial = initial.filter(res => {
        return res.QuantitySold > 0
      })
      if (initial.length > 0) {
        data = initial[0]
      } else {
        data = obj.Conditions[0]
      }
      if (obj.Status == 1) {
        if(val){
          return formatAmount(data.UnderlinedPrice)
        }else{
          return formatAmount(data.Price)
        }
      } else {
        if (data) {
          if(val){
            return data.ShowPrice ? formatAmount(data.UnderlinedPrice) : 0
          }else{
            return data.ShowPrice ? formatAmount(data.Price) : '???'
          }
        } else {
          if(val){
            return 0
          }else{
            return '???'
          }
        }
      }
    },
    cardTimer() {
      this.timer = setInterval(() => {
        this.nowData = this.nowData + 1000;
      }, 1000);
    },
    getCountDown(itemEnd) {
      if(itemEnd){
      itemEnd = itemEnd.toString().replace(/-/g, "/")
      }
      let val = setUTC(itemEnd, -8, 'cn')
      let newval = setUTC(this.nowData, -8)
      return countDown(val, newval, 0)
    },
    CountDown(itemEnd) {
      if(itemEnd){
      itemEnd = itemEnd.toString().replace(/-/g, "/")
      }
      let val = setUTC(itemEnd, -8, 'cn')
      let newval = setUTC(this.nowData, -8)
      return countDown(val, newval)
    },
  },
  //离开页面后清除定时器
  destroyed() {
    clearInterval(this.timer);
  }
};

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/goodslist.css";
.price span{
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/list/storegoods.vue